import React from 'react';
import CurrencyFormat from '../../Formatters/CurrencyFormat';

export default function DigitalCoverageAmounts(start,end,increment) {
var amounts = [];
  for (var i = start; i <= end; i += increment) {
    if (i === start) {
      amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
    } else if (i === end) {
      if (end < 1000000) {
        amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
      } else {
        amounts.push({ label: <CurrencyFormat number={i} whole shortM />, value: i });
      }
    } else {
      amounts.push({ label: '', value: i });
    }
  }

  return amounts;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts.js